module.exports = __webpack_public_path__ + "img/3a55b4e.jpg";